import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Message {
  id?: number;
  message: string | null;
  severity: "success" | "info" | "warning" | "error";
  autoHideDuration?: number;
  anchor?: {
    vertical: "top" | "bottom";
    horizontal: "center" | "left" | "right";
  };
}

interface NotificationState {
  messages: Message[];
}

const initialState: NotificationState = {
  messages: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    showError: (state, action: PayloadAction<string>) => {
      state.messages = [
        ...state.messages,
        {
          id: Date.now(),
          message: action.payload,
          severity: "error",
          anchor: {
            vertical: "top",
            horizontal: "center",
          },
        },
      ];
    },
    // showSuccess: (state, action: PayloadAction<string>) => {
    //   state.message = action.payload;
    //   state.type = "success";
    // },
    clearNotification: (state, action: PayloadAction<number>) => {
      state.messages = state.messages.filter(({ id }) => id !== action.payload);
    },
  },
});

export const { showError, clearNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
